import { Component,Input } from '@angular/core';

@Component({
  selector: 'app-branding',
  template: `
    <a class="matero-branding" href="#/home/dashboard"   >
      <img src="./assets/images/flexivanlogo_dark.png" class="matero-branding-logo-expanded" alt="logo" *ngIf="showlogo=='dark'"  />
      <img src="./assets/images/flexivanlogo_light.png" class="matero-branding-logo-expanded" alt="logo" *ngIf="showlogo=='light'"  />
    </a>
  `,
})

export class BrandingComponent {
  @Input() showlogo ='dark';
 constructor(){
  console.log(this.showlogo);
 }
}
